import i18n from '@/plugins/i18n';
const HeaderKeys = Object.freeze({
  totalAlerts: 'totalAlerts',
  cpu: 'cpu',
  ram: 'ram',
  storage: 'storage',
  network: 'network',
  serviceName: 'serviceName',
  serviceID: 'serviceID',
  instanceName: 'instanceName',
  instanceId: 'instanceId',
  availability: 'availability',
});

const SortKeyMap = Object.freeze({
  totalAlerts: 'ALERTS',
  cpu: 'CPU',
  ram: 'RAM',
  storage: 'STORAGE',
  network: 'NETWORK',
  instanceName: 'NAME',
  availability: 'AVAILABILITY',
});

const VMTableHeaders = () => [
  {
    key: HeaderKeys.instanceName,
    name: i18n.global.t('hostname'),
    width: '15%',
    sortable: true,
  },
  {
    key: HeaderKeys.cpu,
    name: i18n.global.t('cpuUsage'),
    sortable: true,
    width: '14%',
    dataType: 'float',
  },
  {
    key: HeaderKeys.ram,
    name: i18n.global.t('ramAvailable'),
    sortable: true,
    width: '16%',
    dataType: 'float',
  },
  {
    key: HeaderKeys.storage,
    name: i18n.global.t('storageAvailable'),
    sortable: true,
    width: '17%',
    dataType: 'float',
  },
  {
    key: HeaderKeys.network,
    name: i18n.global.t('networkBandwidth'),
    sortable: true,
    width: '25%',
  },
  {
    key: HeaderKeys.availability,
    name: i18n.global.t('avlPer'),
    sortable: true,
    width: '13%',
  },
];

const VMPerformanceSummary = [
  {
    label: i18n.global.t('vm.windows.osNameFlavour'),
    iconName: 'windowsLogo',
    iconHeight: '3rem',
    iconWidth: '3rem',
    metricName: 'os_version',
    isInstanceValue: true,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.hostName'),
    iconName: 'windowsHost',
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'hostname',
    isInstanceValue: true,
  },
];

const VMPerformanceSummaryLinux = [
  {
    label: i18n.global.t('vm.linux.osNameFlavour'),
    iconName: 'linuxLogo',
    iconHeight: '3rem',
    iconWidth: '3rem',
    metricName: 'os_version',
    isInstanceValue: true,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.hostName'),
    iconName: 'windowsHost',
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'hostname',
    isInstanceValue: true,
  },
];

const VMPerformanceSummaryNumbersLinux = [
  {
    label: i18n.global.t('vm.linux.architecture'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'architecture',
    quertType: 'readMetricsValue',
    isInstanceValue: true,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.cpuUsagePercentage'),
    metricName: 'meter_vm_cpu_utilization',
    quertType: 'readMetricsValue',
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    aggregationNum: 100,
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.status'),
    metricName: 'isActive',
    quertType: 'readMetricsValue',
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.ramUsageMb'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'meter_vm_memory_used',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.avlPer'),
    metricName: 'availability',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.cores'),
    metricName: 'cores',
    quertType: 'readMetricsValue',
    isInstanceValue: true,
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.ramUsageMb'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'meter_vm_memory_total',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.cpuCount'),
    metricName: 'meter_vm_process_cpu_usage',
    quertType: 'readMetricsLabelCount',
    isLatestValue: true,
    isInstanceValue: false,
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.linux.ramCount'),
    metricName: 'meter_vm_process_ram_usage',
    quertType: 'readMetricsLabelCount',
    isLatestValue: true,
    isInstanceValue: false,
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isFirstEle: true,
  },
];
const VMPerformanceSummaryNumbers = [
  {
    label: i18n.global.t('vm.windows.architecture'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'architecture',
    quertType: 'readMetricsValue',
    isInstanceValue: true,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.cpuUsagePercentage'),
    metricName: 'windows_vm_cpu_usage_percentage',
    quertType: 'readMetricsValue',
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    aggregationNum: 100,
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.status'),
    metricName: 'isActive',
    quertType: 'readMetricsValue',
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.ramUsageMb'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'windows_vm_memory_usage_used_bytes',
    quertType: 'readMetricsValue',

    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.appoolysDeployed'),
    metricName: 'windows_vm_application_pools_deployed_count',
    quertType: 'readMetricsLabelCount',
    isInstanceValue: false,
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.swapUsagePercentage'),
    metricName: 'windows_vm_swap_usage_percentage',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.ramUsageMb'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'windows_vm_memory_usage_total_bytes',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.readPercent'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'windows_vm_swap_memory_read_percentage',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    isSwap: true,
    isFirstEle: true,
  },
  {
    label: i18n.global.t('vm.windows.writePercent'),
    iconHeight: '2.75rem',
    iconWidth: '2.75rem',
    metricName: 'windows_vm_swap_memory_write_percentage',
    quertType: 'readMetricsValue',
    isInstanceValue: false,
    isSwap: true,
    isFirstEle: true,
  },
];

const VmProcessCpuSummary = () => [
  {
    key: 'processId',
    name: i18n.global.t('processId'),
    width: '18%',
    sortable: false,
    isSearchable: false,
    routable: false,
  },
  {
    key: 'processName',
    name: i18n.global.t('processName'),
    width: '25%',
    sortable: false,
    routable: false,
  },
  {
    key: 'processPath',
    name: i18n.global.t('processPath'),
    width: '30%',
    sortable: false,
    routable: false,
    isEllipsisReq: true,
  },
  {
    key: 'processCpu',
    name: i18n.global.t('cpuUsage'),
    width: '27%',
    sortable: true,
    routable: false,
  },
];

const VmProcessRamSummary = () => [
  {
    key: 'processId',
    name: i18n.global.t('processId'),
    width: '18%',
    sortable: false,
    isSearchable: false,
    routable: false,
  },
  {
    key: 'processName',
    name: i18n.global.t('processName'),
    width: '25%',
    sortable: false,
    routable: false,
  },
  {
    key: 'processPath',
    name: i18n.global.t('processPath'),
    width: '30%',
    sortable: false,
    routable: false,
    isEllipsisReq: true,
  },
  {
    key: 'processRam',
    name: i18n.global.t('ramUsage'),
    width: '27%',
    sortable: true,
    routable: false,
  },
];

export {
  VMTableHeaders,
  SortKeyMap,
  HeaderKeys,
  VMPerformanceSummary,
  VMPerformanceSummaryNumbers,
  VMPerformanceSummaryNumbersLinux,
  VMPerformanceSummaryLinux,
  VmProcessCpuSummary,
  VmProcessRamSummary,
};
